module.exports = "<div class=\"cardup\">\r\n    <h3>{{title}}</h3>\r\n</div>\r\n<div class=\"cardon\">\r\n    <gridster #gridster [id]=\"menuEntryID\" [options]=\"gridsterOptions\">\r\n        <gridster-item *ngFor=\"let favo of entryData, let ix = index\" [item]=\"gridsterItems[ix]\">\r\n            <div style=\"border:2px solid black;\">\r\n                <p style=\"padding: 4px\">\r\n                    {{ favo.Header }}\r\n                </p>\r\n            </div>\r\n        </gridster-item>\r\n    </gridster>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-main/insa-main-widgets/menuEntry.component.html
// module id = 1189
// module chunks = 2